import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Footer from "./footer/Footer";
import AppMain from "./global/AppMain";
import AppRoot from "./global/AppRoot";
import AppWrap from "./global/AppWrap";
import Head from "./head/Head";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";



const Layout = ({ title, ...props }) => {
  const navigate = useNavigate()
  const token = localStorage.getItem("accessToken")
  useEffect(() => {
    if (!token) {
      navigate("/auth-login")
    }
  }, [])

  return (
    <div>
      <Head title={!title && 'Loading'} />
      <AppRoot>
        <AppMain>
          <Sidebar fixed />
          <AppWrap>
            <Header fixed />
            <Outlet />
            <Footer />
          </AppWrap>
        </AppMain>
      </AppRoot>
      <ToastContainer position="top-center" />
    </div>
  );
};
export default Layout;
